export const WriteRight = "WEB_MODULE_PILOT_PEC_EXAM_EVALUATIONS_WRITE";

export const Rights = [
    WriteRight
]
